import { useEffect, useState } from "react";
import { getWorkerImg } from "services/firebase/firebase.service";

interface UseWorkerAvatarParams {
  workerExternalId?: string | null;
  isWorker?: boolean | null;
  initialUrl?: string | null;
}

/**
 * Resolves worker avatar URL based on external id and worker type.
 */
export const useWorkerAvatar = (
  params: UseWorkerAvatarParams,
): string | null => {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(
    params.initialUrl ?? null,
  );
  const isNonWorker = params.isWorker === false;

  useEffect(() => {
    if (isNonWorker || !params.workerExternalId) {
      setAvatarUrl(null);
      return;
    }

    let isMounted = true;
    getWorkerImg(params.workerExternalId).then((res: string | null) => {
      if (!isMounted) return;
      setAvatarUrl(res ?? null);
    });

    return () => {
      isMounted = false;
    };
  }, [isNonWorker, params.workerExternalId]);

  return avatarUrl;
};
